import { Component, OnInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { CoreLogService } from "../../services/log.service";
import { Router } from "@angular/router";
import { MainnavService, ViewType } from "../mainNav/mainnav.service";
import { CoreLanguageService } from "../../services/language.service";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { IOSHelperService } from "../../services/IOSHelper.service";
import Utils from "../../shared/utils";
import { Observable, Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { AnnounceDialogComponent, WarningdialogComponent } from "../../modalDialogs";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { RemoteOrderGroupDefineTimeService } from "./remoteOrderGroupDefineTime.service";
import { IDayList, ISelectedDay, ISelectedTime, IServiceOpenTime } from "./remoteOrderGroupDefineTime.facade";
import { AnounceModalResult, WebShopMode } from "../../shared/contentTypes";
import { CreateGroupVariant } from "../../services/IRemoteGroupOrderService";
import * as moment from "moment";

@Component({
  selector: "remoteOrderGroupDefineTime",
  templateUrl: "./remoteOrderGroupDefineTime.component.html",
  styleUrls: ["./remoteOrderGroupDefineTime.component.scss"],
  providers: [RemoteOrderGroupDefineTimeService, OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class RemoteOrderGroupDefineTime implements OnInit, OnDestroy {
  private _langSubscriber: Subscription;

  public serviceId: number;
  public dayList$: Observable<IDayList[]>
  public serviceOpenTime$: Observable<IServiceOpenTime[]>
  public serviceOrderTime$: Observable<IServiceOpenTime[]>
  public canCreateGroup$: Observable<boolean>;
  /** Service day (Pick up /delivery)*/
  public get selectedServiceDay(): ISelectedDay {
    const me = this;
    return me._remoteOrderGroupDefineTimeService.SelectedServiceDay;
  }
  /** Day by which the order must 'Ready'*/
  public get selectedOrderDay(): ISelectedDay {
    const me = this;
    return me._remoteOrderGroupDefineTimeService.SelectedOrderDay;
  }
  /** Service time (Pick up /delivery)**/
  public selectedServiceTime: ISelectedTime = { timeValue: "" };
  public selectedServiceTimeIndex: number = -1;
  /** Order time by which the order must 'Ready'**/
  public selectedOrderTime: ISelectedTime = { timeValue: "" };
  public selectedOrderTimeIndex: number = -1;

  /** Get as soon as possible value */
  public get orderASAP(): boolean {
    const me = this;
    return me._remoteOrderGroupDefineTimeService.orderASAP;
  }
  public isSmallView: boolean = false;
  public get hasTimeSelection(): boolean {
    return this._remoteOrderGroupDefineTimeService.hasTimeSelection;
  }

  constructor(private _router: Router
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreLanguageService: CoreLanguageService
    , private _mainnavService: MainnavService
    , private _internationalisationService: InternationalisationService
    , private _remoteOrderGroupDefineTimeService: RemoteOrderGroupDefineTimeService
    , private _iosHelperService: IOSHelperService
    , private _bottomSheetHelperService: BottomSheetHelperService
    , private _overlaySpinnerService: OverlaySpinnerService) {
    const me = this;
    me.isSmallView = me._mainnavService.viewType === ViewType.Small;
  }

  ngOnDestroy(): void {
    const me = this;
    if (me._langSubscriber) {
      me._langSubscriber.unsubscribe()
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("RemoteOrderGrouDefineTime.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me._remoteOrderGroupDefineTimeService.initial();
    me.canCreateGroup$ = me._remoteOrderGroupDefineTimeService.canCreateGroup$;
    me.dayList$ = me._remoteOrderGroupDefineTimeService.dayList$;
    me.serviceOpenTime$ = me._remoteOrderGroupDefineTimeService.serviceOpenTime$;
    me.serviceOrderTime$ = me._remoteOrderGroupDefineTimeService.serviceOrderTime$;
    me.serviceId = me._remoteOrderGroupDefineTimeService.serviceID;
    me._langSubscriber = me._internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });
  }

  /** Returns the service day label based on the service ID. */
  public get serviceDayLabel() {
    const me = this;
    const deliveryDayLabel = "phRemoteOrder_DefineTime_Sevice_Delivery_Day_Label";
    const PickupDayLabel = "phRemoteOrder_DefineTime_Sevice_Pickup_Day_Label"
    return me._coreLanguageService.value(me.isGroupOrderDelivery ? deliveryDayLabel : PickupDayLabel);
  }

  /** Returns the service time label based on the service ID. */
  public get serviceTimeLabel() {
    const me = this;
    const deliveryTimeLabel = "phRemoteOrder_DefineTime_Sevice_Delivery_Time_Label";
    const PickupTimeLabel = "phRemoteOrder_DefineTime_Sevice_Pickup_Time_Label"
    return me._coreLanguageService.value(me.isGroupOrderDelivery ? deliveryTimeLabel : PickupTimeLabel);
  }

  /** Returns the info label based on the service ID. */
  public get serviceTimeInfo() {
    const me = this;
    const deliveryInfoLabel = "phRemoteOrder_DefineTime_SeviceTime_Delivery_Info";
    const pickupInfoLabel = "phRemoteOrder_DefineTime_SeviceTime_Pickup_Info"
    return me._coreLanguageService.value(me.isGroupOrderDelivery ? deliveryInfoLabel : pickupInfoLabel);
  }

  /** Returns the notice about lead time*/
  public get orderTimeNotice() {
    const me = this;
    const leadTime = me._remoteOrderGroupDefineTimeService.leadTime;
    return me._coreLanguageService.value("phRemoteOrder_DefineTime_Order_Notice").replace("{minutes}", leadTime.toString())
  }

  /*** Checks if the service mode. */
  public get isGroupOrderDelivery() {
    const me = this;
    return me.serviceId === WebShopMode.DeliveryGroup;
  }

  /**
   * Handles selection change event by updating the selected day.
   * 
   * @param event - The selection change event.
   * @param dayList - List of days .
   */
  public async selectionChangeServiceDay(event: any, dayList: IDayList[]) {
    const me = this;
    const selectedValue = event.target.value;
    const selectedDay = dayList.find(day => day.value === selectedValue);
    if (selectedDay) {
      const _selectedDay: ISelectedDay = { value: selectedDay.value, useTime: selectedDay.use_time };
      me._remoteOrderGroupDefineTimeService.setServiceDay(_selectedDay);
      me._remoteOrderGroupDefineTimeService.setOrderDay(_selectedDay);
      await me._remoteOrderGroupDefineTimeService.setAvailableTimeList();
      me.PushChanges();
    }
  }

  /**  Compares the given day with the currently selected day.*/
  public isServiceDayselected(day: string): boolean {
    const me = this;
    const dateString = Utils.GetDateFromMomentString(day);
    const selectedDay = Utils.GetDateFromMomentString(me.selectedServiceDay.value);
    return dateString === selectedDay;
  }

  /**
 * Handles the change in service time selection.
 * Updates the selected service time based on the provided index anssets the 'order ASAP' status
 * 
 * @param index - The index of the selected service time.
 * @param timeList - The array of available service time.
 */
  public onServiceTimeChange(index: string, timeList: IServiceOpenTime[]) {
    const me = this;
    const selectedIndex = +index;
    const serviceTime = timeList[selectedIndex];
    if (!serviceTime) return;
    me._remoteOrderGroupDefineTimeService.setOrderAsap(serviceTime.asap);
    me.selectedServiceTime = { timeValue: serviceTime.value };
    me.selectedServiceTimeIndex = selectedIndex;
    me._remoteOrderGroupDefineTimeService.setSelectedServiceTime(me.selectedServiceTime);
    me.updateOrderTime(serviceTime.asap);
    me.PushChanges();
  }

  /** Checks if the given time is selected.*/
  public isTimeSelected(availableTime: IServiceOpenTime, selectedTime: ISelectedTime, index: number, selectedIndex: number): boolean {
    const me = this;
    const hasAsap = me.orderASAP === availableTime.asap;
    const selected = selectedTime.timeValue === availableTime.value;
    return selected && hasAsap && index === selectedIndex;
  }

  /** Handles the selection change event for the order day */
  public async selectionChangeOrderDay(event: any, orderDayList: IDayList[]) {
    const me = this;
    const selectedValue = event.target.value;
    const selectedOrderDay = orderDayList.find(day => day.value === selectedValue);
    if (selectedOrderDay) {
      const _selectedOrderDay: ISelectedDay = { value: selectedOrderDay.value, useTime: selectedOrderDay.use_time };
      me._remoteOrderGroupDefineTimeService.setOrderDay(_selectedOrderDay);
      await me._remoteOrderGroupDefineTimeService.setAvailableTimeList();
      me.PushChanges();
    }
  }

  /** Compares the given date with the currently selected order day.*/
  public isOrderDaySelected(date: string): boolean {
    const me = this;
    // Convert the input date string to a standardized date format.
    if (me.selectedOrderDay) {
      const dateString = Utils.GetDateFromMomentString(date);
      const selectedOrderDay = Utils.GetDateFromMomentString(me.selectedOrderDay.value);
      return dateString === selectedOrderDay;
    }
  }

  /** Checks if the given time is selected.*/
  public isOrderTimeSelected(availableTime: IServiceOpenTime, index: number): boolean {
    const selected = availableTime.value === this.selectedOrderTime.timeValue;
    return selected && index === this.selectedOrderTimeIndex;
  }

  /**  Updates the selected order time and sets it in the service. */
  public onOrderTimeChange(index: string, timeList: IServiceOpenTime[]) {
    const me = this;
    const orderTime = timeList[+index];
    if (orderTime) {
      me.selectedOrderTime = { timeValue: orderTime.value };
      me._remoteOrderGroupDefineTimeService.setOrderTime(me.selectedOrderTime);
    }
  }

  /** Updates the selected order time based on the selected service time. */
  private updateOrderTime(selectedServiceTimeAsap: boolean): void {
    const me = this;
    if (me.selectedServiceTime.timeValue !== "") {
      let OrderTimeList: IServiceOpenTime[] = [];
      me._remoteOrderGroupDefineTimeService.serviceOrderTime$.pipe(take(1)).subscribe(value => OrderTimeList = value).unsubscribe();
      me.selectedOrderTime = { timeValue: me.findNextAvailableTime(OrderTimeList, selectedServiceTimeAsap) };
      me._remoteOrderGroupDefineTimeService.setOrderTime(me.selectedOrderTime);
      me.PushChanges();
    }
  }

  /**
   * Finds the nearest available order time based on the lead time.
   * @param timeList List of available order time.
   * @param selectedServiceTimeAsap 
   * @returns The nearest available order time.
   */
  private findNextAvailableTime(timeList: IServiceOpenTime[], selectedServiceTimeAsap: boolean): string {
    if (timeList.length === 0) return "";
    const selectedServiceTime = moment(this.selectedServiceTime.timeValue);
    const leadTime = this._remoteOrderGroupDefineTimeService.leadTime;
    const minOrderTime = selectedServiceTime.subtract(leadTime, "minutes");
    let nearestTime = "";
    for (let i = 0; i < timeList.length; i++) {
      //if asap then set the selected time to first available time
      const firstAvailableTimeIsSelected = this.selectedServiceTimeIndex === 0;
      if (firstAvailableTimeIsSelected && selectedServiceTimeAsap) {
        this.selectedOrderTimeIndex = 0;
        return nearestTime = timeList[0].value;
      } else {
        const orderDate = moment(timeList[i].value);
        if (orderDate.isSameOrBefore(minOrderTime)) {
          nearestTime = timeList[i].value;
          this.selectedOrderTimeIndex = i;
        } else {
          break;
        }
      }
    }
    return nearestTime;
  }

  /**Checks if the service day is before the order day*/
  private _isServiceDayBefore(): boolean {
    const me = this;
    const orderday = moment(me.selectedOrderDay.value);
    const serviceDay = moment(me.selectedServiceDay.value);
    return serviceDay.isBefore(orderday, 'day');
  }

  /**
   * Attempts to create a group and navigates to the success page.
   * Handles different outcomes: success, max group count reached, or failure.
   */
  public async CreateGroupAndNavigate(): Promise<void> {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    let canCreateGroup = false;
    me._remoteOrderGroupDefineTimeService.canCreateGroup$.pipe(take(1)).subscribe(value => canCreateGroup = value).unsubscribe();
    if (canCreateGroup) {
      if (me._isServiceDayBefore()) {
        me._overlaySpinnerService.HideLayoutSpinner();
        me._OpenWarningTimeConflict();
      } else {
        await me._checkStateAndNavigate();
      }
    } else {
      me._OpenWarningMaxGroupCountReached();
    }
  }

  /** * Handles group creation result and navigates or shows warnings. */
  private async _checkStateAndNavigate() {
    const me = this;
    const createResponse = await me._remoteOrderGroupDefineTimeService.createGroupResult();
    me._overlaySpinnerService.HideLayoutSpinner();
    switch (createResponse) {
      case CreateGroupVariant.Okay:
        me._router.navigate(["/remoteOrderGroupCreateConfirm"]);
        break;
      case CreateGroupVariant.isTooSoon:
        me._OpenWarningTooSoon();
        break;
      case CreateGroupVariant.TimeConflict:
        me._OpenWarningTimeConflict();
        break;
      case CreateGroupVariant.Fail:
        me._OpenWarningCreateGroupFailed();
        break;
      default:
        me._OpenWarningCreateGroupFailed();
        me._coreLogService.error("RemoteOrderGrouDefineTime._checkStateAndNavigate", "unknown CreateGroupResult", createResponse);
        break;
    }
  }

  /**
   * Checks if the button should be active
   * @returns true if both username and group name inputs are valid.
   */
  public setButtonActive(): boolean {
    const me = this;
    const hasServiceDay = me.selectedServiceDay ? !Utils.IsNullOrEmpty(me.selectedServiceDay.value) : false;
    const hasSericeTime = me.selectedServiceTime ? !Utils.IsNullOrEmpty(me.selectedServiceTime.timeValue) : false;
    const hasOrderDay = me.selectedOrderDay ? !Utils.IsNullOrEmpty(me.selectedOrderDay.value) : false;
    const hasOrderTime = me.selectedOrderTime ? !Utils.IsNullOrEmpty(me.selectedOrderTime.timeValue) : false;
    return hasServiceDay && hasSericeTime && hasOrderDay && hasOrderTime;
  }

  /**
 * Opens a warning dialog when the maximum number of group orders has been reached.
 * After the dialog is dismissed, the user is redirected to the home page.
 */
  private _OpenWarningTooSoon() {
    const me = this;
    const leadTime = me._remoteOrderGroupDefineTimeService.leadTime;
    const infoLabel = me._coreLanguageService.value("phRemoteOrder_Dialog_Time_Conflict_TooSoon_Info").replace('{minutes}', leadTime.toString())
    const warningDialog = me._bottomSheetHelperService.open(AnnounceDialogComponent, {
      data: {
        title: "phRemoteOrder_Dialog_Time_Conflict_Title"
        , content: infoLabel
        , firstBtnLabel: "phRemoteOrder_Dialog_Time_Conflict_button_label"
        , secondBtnLabel: "phGlobal_Continue"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningDialog.afterDismissed().subscribe((result: AnounceModalResult) => {
      if (result === AnounceModalResult.FirstButton) {
      } else if (result === AnounceModalResult.SecondButton) {
        me._router.navigate(["/"]);
      } else {
        // nothing
      }
    });

  }

  /**
   * Opens a warning dialog when the group defination fails.
   * After the dialog is dismissed, the user is redirected to the home page.
   */
  private _OpenWarningTimeConflict() {
    const me = this;
    const warningDialog = me._bottomSheetHelperService.open(AnnounceDialogComponent, {
      data: {
        title: "phRemoteOrder_Dialog_Time_Conflict_Title"
        , content: "phRemoteOrder_Dialog_Time_Conflict_Info"
        , firstBtnLabel: "phRemoteOrder_Dialog_Time_Conflict_button_label"
        , secondBtnLabel: "phGlobal_Continue"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningDialog.afterDismissed().subscribe((result: AnounceModalResult) => {
      if (result === AnounceModalResult.FirstButton) {
      } else if (result === AnounceModalResult.SecondButton) {
        me._router.navigate(["/"]);
      } else {
        // nothing
      }
    });
  }

  /**
* Opens a warning dialog when the maximum number of group orders has been reached.
* After the dialog is dismissed, the user is redirected to the home page.
*/
  private _OpenWarningMaxGroupCountReached() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phRemoteOrder_Dialog_GroupMaxCountReached_Title"
        , content: "phRemoteOrder_Dialog_GroupMaxCountReached_Info"
        , btnLabel: "phGlobal_Continue"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningButtomSheet.afterDismissed().subscribe((result) => {
      if (result) {
        me._router.navigate(["/"]);
      }
    });
  }

  /** Warning dialog: Max count reached  */
  private _OpenWarningCreateGroupFailed() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(WarningdialogComponent, {
      data: {
        title: "phRemoteOrder_Dialog_GroupFail_Title"
        , content: "phRemoteOrder_Dialog_GroupFail_Info"
        , btnLabel: "phGlobal_Continue"
      },
      panelClass: "mat-bottom-sheet-container-medium"
    });
    warningButtomSheet.afterDismissed().subscribe((result) => {
      if (result) {
        me._router.navigate(["/"]);//home
      }
    });
  }

  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  /** navigate back on swipe from left to right */
  public SwiperNavigateBack() {
    const me = this;
    if (me.isSmallView == true) {
      me.navigateBack();
    }
  }

  /** navigate to home screen */
  public navigateBack(): void {
    const me = this;
    me._router.navigate(["/"]);
  }
}